import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { TICKET_SCANNERS_FEATURE_GROUP } from './group';

export const TICKET_SCANNERS_FEATURES = {
  ACCESS: {
    guid: '282960a2-1cf9-4757-972a-94f2aa0f0001',
    name: 'ticket-scanners:access',
    description: 'Access the Ticket Scanners app',
    action: 'read',
    product: 'app',
    parentGuid: TICKET_SCANNERS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { TICKET_SCANNERS_FEATURE_GROUP } from './group';

export const TICKET_SCANNERS_MODULE: FeatureModule = {
  product: 'app',
  groups: [TICKET_SCANNERS_FEATURE_GROUP],
  features: featureList(TICKET_SCANNERS_FEATURES),
};
